export enum FieldsEnum {
  Symbol = 'symbol',
  ContractDate = 'contractDate',
  Put = 'put',
  StrikePrice = 'strikePrice',
  IsShort = 'isShort',
  Amount = 'amount',
}

export enum PositionEnum {
  Short = 'Short',
  Long = 'Long',
}

export enum PutCallEnum {
  Put = 'PUT',
  Call = 'CALL',
}
